// extracted by mini-css-extract-plugin
export default {"title":"c3_c1","noTag":"c3_gY","toplistDate":"c3_kl"};